import React from "react";
import { useTranslation } from "react-i18next";

const Comment = (props) => {
    const { t } = useTranslation();
    const classTextArea=(props.background_exist) ? "transparent-textarea":""
    return (
        <>
            <textarea
                placeholder={t('yourComment')}
                name='user_comment'
                className={classTextArea}
                value={props.comment}
                onChange={props.commentHandler}
            />
        </>
    );
}
export default Comment;